import React from 'react';
import styles from './Search.module.scss';

const SearchNav = () => (
  <div className={styles.searchBox}>
    <div className={styles.searchImg}>
      <img src="/images/chat/searchIcon.svg" alt="" style={{ height: 17.5, width: 17.5 }} />
    </div>
    <div className={styles.search}>
      <input placeholder="Search..." className={styles.searchInput} />
    </div>
  </div>
);

export default SearchNav;
